import styles from "./AssessmentGet.module.scss";
import { Card } from "./Card";

const cards = [
    {
        title: "A detailed overview of your physical and mental state.",
        text: "After the diagnosis, you will know exactly on which energy layer you have a blockage, which area of life it affects, and how.",
        position: "01",
    },
    {
        title: "Understanding the causes of your condition and how to help yourself.",
        text: "",
        position: "02",
    },
    {
        title: "Individual methods for healing and cleansing the subtle body, specially selected for you.",
        text: "You will know exactly which trees are suitable for you, which exercises and in what quantity will be effective for you. You will receive a precise selection of the time to perform each exercise.",
        position: "03",
    },
    {
        title: "A plan for the next 30 days",
        text: "with the possibility to get answers to emerging questions.",
        position: "04",
    },
];

export const AssessmentGet = () => {
    return (
        <div className={styles.AssessmentGet}>
            <div className={styles.title}>
                <span>What you get</span> from the consultation?
            </div>
            <div className={styles.content}>
                {cards.map((card, index) => {
                    return (
                        <Card
                            text={card.text}
                            title={card.title}
                            position={card.position}
                            key={index}
                        />
                    );
                })}
            </div>
        </div>
    );
};
